class levelsServices {
    constructor($resource,SERVICE_URL_CONSTANT) {
		const services = $resource(SERVICE_URL_CONSTANT.adminPanel +'/levels/:route',{},{
			getLevels:{
				method:'GET',
				params : {}
			},
			getLevelDetails:{
				method:'GET',
				params : {
					route: 'id'
				}
			},
			saveLevels:{
				method:'POST',
				params : {}
			},
			updateLevels:{
				method:'PUT',
				params : {}
			},

		});

		return {
			services : services
		};
	}
}

levelsServices.$inject=['$resource','SERVICE_URL_CONSTANT']

export default  angular.module('services.levelsServices', [])
.service('levelsServices', levelsServices)
.name;



// WEBPACK FOOTER //
// ./src/app/admin-panel/levels/levelsServices.js